/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { Warehouse } from '../../types';
import { GetWarehouseAction, GetWarehouseActionTypes } from './types';

export interface GetWarehouseState {
  warehouse: Warehouse;
  error: Error;
  loading: boolean;
}

export const initialGetWarehouseState: GetWarehouseState = {
  warehouse: undefined,
  error: undefined,
  loading: false,
};

export default function getWarehouseReducer(state = initialGetWarehouseState, action: GetWarehouseAction) {
  switch (action.type) {
    case GetWarehouseActionTypes.GET_WAREHOUSE:
      return update(state, {
        $unset: ['error'],
        loading: { $set: true },
      });

    case GetWarehouseActionTypes.GET_WAREHOUSE_SUCCESS:
      return update(state, {
        $unset: ['error'],
        loading: { $set: false },
        warehouse: { $set: action.warehouse },
      });

    case GetWarehouseActionTypes.GET_WAREHOUSE_ERROR:
      return update(state, {
        error: { $set: action.error },
        loading: { $set: false },
      });

    default:
      return state;
  }
}
